/**
 *
 * @desc LightboxUtils utility
 *
 */
class LightboxUtils {

    static getClipIndex = (type, index, results = []) => {

        if(!type || (!index && index !== 0) || results.length < 1) {
    
            return 0;
    
        }
    
        const minIndex = 0;
        const maxIndex = results.length - 1;

        if (type === 'previous') {

            return  index !== minIndex ? index - 1 : minIndex;

        }

        return index >= minIndex && index < maxIndex ? index + 1 : index;

    }

    static preloadData = (index, totalResults, results = [], fetchMoreData) => {

        if(!fetchMoreData) {
    
            return null;
    
        }
        
        const isAllDataLoaded = (results.length === totalResults);
    
        if (!isAllDataLoaded && ((results.length - index) <= 3)) {
    
            fetchMoreData();
    
        }
    
    }

    static resetVideoPlayback = (playerWrapper, isPrerollAdEnabled) => {

        if(!playerWrapper) {

            return null;

        }
        
        if(isPrerollAdEnabled) {

            playerWrapper.resetPlayback();

        }

    }

    static pauseVideoPlayback = (player, isPlayerPaused) => {

        if(!player) {

            return null;

        }

        if(!isPlayerPaused) {

            player.pause();

        }

    }

    static playVideoPlayback = (player, isPlayerPaused) => {

        if(!player) {

            return null;

        }

        if(isPlayerPaused) {

            player.play();

        }

    }

    static destroyPlayer = (player) => {

        if(!player) {

            return null;

        }


        player.destroy();

    }

}

export default LightboxUtils;
